import { MDBContainer } from "mdb-react-ui-kit";
import { Avatar, message } from "antd";

import { useNavigate } from "react-router-dom";
// import DataTable from "./DataTable";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";

import "../PassportDetails.css";
import $ from "jquery";
import "datatables.net";
import BottomNavigationBar from "../BottomNavigation";
import { useSelector, useDispatch } from "react-redux";

import NotArrangeHotelGrid from "./NotArrangeHotelGrid";
import Drawer1 from "../drawer";

function NotArrangeHotel() {
const [value, setValue] = useState(0);
  const [showDrawer, setshowDrawer] = useState(false);
  const navigate = useNavigate();
  const [voucherNo, setVoucherNo] = useState("");
  const [checkInDate, setCheckInDate] = useState("");
  const [transportType, setTransportType] = useState("");
  const [transportCompany, setTransportCompany] = useState("");
  const [vehicleNo, setVehicleNo] = useState("");
  const [actualSeat, setActualSeat] = useState("");
  const [driverNo, setDriverNo] = useState("");

  const [voucherNoError, setVoucherNoError] = useState("");
  const [checkInDateError, setCheckInDateError] = useState("");
  const [transportTypeError, setTransportTypeError] = useState("");
  const [transportCompanyError, setTransportCompanyError] = useState("");
  const [vehicleNoError, setVehicleNoError] = useState("");
  const [actualSeatError, setActualSeatError] = useState("");
  const [driverNoError, setDriverNoError] = useState("");

  const FormData = require("form-data");

  const handleTransport = async (e) => {
    e.preventDefault();

    if (voucherNo === "") {
      setVoucherNoError("Voucher No is required");
    } else {
      setVoucherNoError("");
    }

    if (checkInDate === "") {
      setCheckInDateError("Check-In Date is required");
    } else {
      setCheckInDateError("");
    }

    if (transportType === "") {
      setTransportTypeError("Transport Type is required");
    } else {
      setTransportTypeError("");
    }

    if (transportCompany === "") {
      setTransportCompanyError("Transport Company is required");
    } else {
      setTransportCompanyError("");
    }

    if (vehicleNo === "") {
      setVehicleNoError("Vehicle No is required");
    } else {
      setVehicleNoError("");
    }

    if (actualSeat === "") {
      setActualSeatError("Actual Seat is required");
    } else {
      setActualSeatError("");
    }

    if (driverNo === "") {
      setDriverNoError("Driver No is required");
    } else {
      setDriverNoError("");
    }

    if (
      voucherNo !== "" &&
      checkInDate !== "" &&
      transportType &&
      transportCompany !== "" &&
      vehicleNo !== "" &&
      actualSeat &&
      driverNo
    ) {
      try {
        const formData = new FormData();

        formData.append(
          "key",
          "UXVpUGVja0BBUElAS0VZQEZPUkBEQVRBQE1JTklORzkxNTY2"
        );
        formData.append("voucherNo", voucherNo);
        formData.append("checkInDate", checkInDate);
        formData.append("transportType", transportType);
        formData.append("transportCompany", transportCompany);
        formData.append("vehicleNo", vehicleNo);
        formData.append("actualSeat", actualSeat);
        formData.append("driverNo", driverNo);
        // formData.append('year', year);ccc

        const response = await axios.post(
          "https://api.tripplanner.ae/mis/actual-transport-activity",
          formData,
          {
            // headers: formData.getHeaders()
            headers: formData.getheaders?.(),
          }
        );

        // Assuming the API returns a token or some authentication information
        const { token } = response.data;

        // Store the token in local storage or a state management solution like Redux
        // localStorage.setItem('token', token);

        message.success("Login successful");
        console.log(
          "tansport-submit",
          voucherNo,
          checkInDate,
          transportType,
          transportCompany,
          vehicleNo,
          actualSeat,
          driverNo
        );
        navigate("/actual-hotel");
      } catch (error) {
        // Handle the error, such as displaying an error message to the user
        console.error("Error logging in:", error);
        message.error("Error logging in. Please try again.");
      }
    }
  };

  function addNewColumn() {
    var table = document.querySelector(".table");
    var rows = table.getElementsByTagName("tr");

    for (var i = 0; i < rows.length; i++) {
      var cell = document.createElement("td");
      rows[i].appendChild(cell);
    }
  }

  const handleLogout = () => {
    navigate("/login");
  };

  const handleDrawer = () => {
    setshowDrawer(true);
  };

  const tableRef = useRef(null);
  const [expandedRows, setExpandedRows] = useState([]);

  useEffect(() => {
    $(tableRef.current).DataTable();

    return () => {
      // Destroy the DataTable instance when the component unmounts
      $(tableRef.current).DataTable().destroy(true);
    };
  }, []);

  const toggleExpansion = (rowIndex) => {
    setExpandedRows((prevExpandedRows) => {
      const updatedExpandedRows = [...prevExpandedRows];
      updatedExpandedRows[rowIndex] = !updatedExpandedRows[rowIndex];
      return updatedExpandedRows;
    });
  };


  return (
    <>
    {showDrawer && <Drawer1 showDrawer={showDrawer} />}
    <div className="background-image-allow-transport">
      {/* <div className="dark-overlay"></div> */}

      <MDBContainer breakpoint=" p-4">
        <div className="">
          <div>
            <div
              className="navebar"
              style={{
                background: "",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              <img className="logo" src={window.logo} alt="logo" />
              <Avatar
                className="profile"
                alt="Remy Sharp"
                src={window.profile}
              />
            </div>
            <NotArrangeHotelGrid />
          </div>
        </div>
      </MDBContainer>

      <div className="bottom-bar-lay">
        <BottomNavigationBar />
      </div>
    </div>
  </>
    
  )
}

export default NotArrangeHotel;